// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-modules-template-index-tsx": () => import("./../../../src/modules/template/index.tsx" /* webpackChunkName: "component---src-modules-template-index-tsx" */),
  "component---src-modules-template-iplatform-tsx": () => import("./../../../src/modules/template/iplatform.tsx" /* webpackChunkName: "component---src-modules-template-iplatform-tsx" */),
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */)
}

